{
  "breaches": {
    "count": "Los datos de tu cuenta se han filtrado en {count} filtraciones de datos.",
    "discovered": "Esta filtración se detectó por primera vez el {date}.",
    "empty": {
      "text": "No hemos encontrado filtraciones de datos de tu cuenta.",
      "title": "No se han encontrado filtraciones de datos"
    },
    "high": "Alto",
    "medium": "Medio",
    "title": "Filtraciones",
    "watchlist": {
      "button": "Añadir correo electrónico",
      "text": "Direcciones de correo supervisadas",
      "title": "Lista de seguimiento"
    }
  },
  "cards": {
    "breaches": {
      "text": "En esta página puedes consultar en cuántas filtraciones de datos ha aparecido tu cuenta. Clasificamos cada filtración según su gravedad y el tipo de datos expuestos. Si tus datos se han visto afectados, cambia tus contraseñas cuanto antes.",
      "title": "¿Se han filtrado tus datos?"
    },
    "overview": {
      "text": "¡Hola, {name}! Como quizá sepas, los ataques de phishing son cada vez más complejos y peligrosos. En el Hub puedes seguir tu progreso y aprender más sobre los ciberataques que amenazan a tu empresa. Completa los retos de seguridad y conviértete en una persona experta en poco tiempo.",
      "title": "¡Te damos la bienvenida al Hub!"
    },
    "quiz": {
      "text": "Demuestra tus habilidades con este cuestionario interactivo y aprende a distinguir los correos legítimos de los de phishing. Comprobarás cuánto sabes y cómo te desenvuelves ante amenazas reales.",
      "title": "¡Pon a prueba tus conocimientos!"
    },
    "simulations": {
      "text": "En esta página puedes consultar los detalles de las simulaciones de Moxso que has recibido en los últimos 90 días. Comprender cómo se diseñan los correos de phishing te ayudará a identificarlos y a protegerte.",
      "title": "¿Has caído en un phishing?"
    },
    "videos": {
      "text": "Descubre en esta página las últimas ciberamenazas y aprende a proteger tus datos y tu empresa. Nuestros vídeos de formación están disponibles siempre que los necesites.",
      "title": "¡Preparados, listos, acción!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certificado de finalización",
    "certificate_unlocked": "Certificado desbloqueado",
    "share_on_linkedin": "Compartir en LinkedIn",
    "show_certificate": "Ver certificado",
    "text": "Tienes un certificado de un curso reciente. ¿Por qué no lo compartes?"
  },
  "courses": {
    "all": "Todos los cursos",
    "completed": {
      "badge": "Completado",
      "button": "Finalizar curso",
      "text": "Has completado el curso",
      "title": "¡Muy bien!"
    },
    "content": {
      "breach": {
        "text": "Activa la detección de filtraciones para tu cuenta",
        "title": "Configurar la detección de filtraciones"
      },
      "download": {
        "button": "Descargar"
      },
      "introduction": {
        "contents": "Contenido",
        "start": "Iniciar curso",
        "text": "Resumen del curso y de lo que vas a aprender",
        "title": "Introducción"
      },
      "quiz": {
        "choose_answer": "Elige la respuesta correcta:",
        "correct": "Correcto",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Respuesta correcta",
        "next_question": "Siguiente pregunta",
        "oh_no": "¡Qué pena!",
        "question_of": "Pregunta {current} de {total}",
        "result": {
          "button": "Finalizar cuestionario",
          "text": "Has respondido correctamente a {correct} de {total} preguntas.",
          "title": "¡Bien hecho!",
          "title_fail": "¡Ya casi lo tienes!"
        },
        "text": "Pon a prueba tus habilidades con un cuestionario",
        "title": "Cuestionario",
        "view_results": "Ver resultado",
        "well_done": "¡Bien hecho!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Tu respuesta"
      },
      "video": {
        "text": "Aprende los conceptos clave con este vídeo"
      }
    },
    "continue": "Continuar",
    "featured": "Cursos destacados",
    "lessons": "{count} lecciones",
    "progress": {
      "button": "Continuar",
      "text": "Has completado el {pct}% de este curso"
    },
    "skip_video": {
      "button": "Omitir",
      "text": "Ya has visto este vídeo. ¿Quieres omitirlo?"
    },
    "start_over": "Volver a empezar",
    "title": "Cursos"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "La pregunta ha caducado",
        "network": "Se ha producido un error",
        "noResponse": "No se ha recibido ninguna respuesta del servidor",
        "streaming": {
          "manifest": "Se ha producido un error al reproducir el vídeo",
          "platform": "Este vídeo no es compatible con tu dispositivo",
          "unavailable": "Este vídeo no está disponible"
        },
        "unknown": "Se ha producido un error desconocido"
      },
      "messages": {
        "auth_failed": "Correo electrónico no válido",
        "csrf": "Actualiza la página e inténtalo de nuevo",
        "email_missing": "No hay ninguna dirección de correo asociada a la cuenta",
        "file_not_found": "Archivo no encontrado",
        "general_exception": "Se ha producido un error",
        "invalid_answer": "Respuesta no válida",
        "invalid_course": "Curso no válido",
        "invalid_domain": "Dominio no válido",
        "invalid_email": "Correo electrónico no válido",
        "invalid_grant": "No se ha podido contactar con el proveedor",
        "invalid_locale": "Traducción no encontrada",
        "invalid_option": "Opción no válida",
        "invalid_permissions": "No tienes autorización para utilizar esta función",
        "invalid_point": "Punto no válido",
        "invalid_provider": "Proveedor no válido",
        "invalid_quiz": "Cuestionario no válido",
        "invalid_token": "Tu sesión ha caducado",
        "invalid_video": "Vídeo no válido",
        "missing_code": "Inténtalo de nuevo",
        "two_factor_code_expired": "El código de autenticación de dos factores ha caducado",
        "two_factor_code_invalid": "El código de autenticación de dos factores no es válido",
        "unauthorized": "No tienes autorización para utilizar esta función",
        "user_not_found": "El usuario no existe"
      },
      "validations": {
        "messages": {
          "throttle": "Demasiados intentos de inicio de sesión. Inténtalo más tarde."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Saldos de cuentas",
        "address_book_contacts": "Contactos de la agenda",
        "age_groups": "Grupos de edad",
        "ages": "Edades",
        "appointments": "Citas",
        "apps_installed_on_devices": "Aplicaciones instaladas en los dispositivos",
        "astrological_signs": "Signos del zodiaco",
        "audio_recordings": "Grabaciones de audio",
        "auth_tokens": "Tokens de autenticación",
        "avatars": "Avatares",
        "bank_account_numbers": "Números de cuentas bancarias",
        "beauty_ratings": "Valoraciones de belleza",
        "biometric_data": "Datos biométricos",
        "bios": "Biografías",
        "browser_user_agent_details": "Detalles del agente de usuario del navegador",
        "browsing_histories": "Historiales de navegación",
        "buying_preferences": "Preferencias de compra",
        "car_ownership_statuses": "Situación de propiedad de vehículos",
        "career_levels": "Niveles profesionales",
        "cellular_network_names": "Nombres de redes móviles",
        "charitable_donations": "Donaciones benéficas",
        "chat_logs": "Registros de chat",
        "credit_card_cvv": "CVV de tarjetas de crédito",
        "credit_cards": "Tarjetas de crédito",
        "credit_status_information": "Información de solvencia crediticia",
        "customer_feedback": "Comentarios de clientes",
        "customer_interactions": "Interacciones con clientes",
        "dates_of_birth": "Fechas de nacimiento",
        "deceased_date": "Fecha de defunción",
        "deceased_statuses": "Estado de fallecimiento",
        "device_information": "Información de dispositivos",
        "device_serial_numbers": "Números de serie de dispositivos",
        "device_usage_tracking_data": "Datos de seguimiento del uso de dispositivos",
        "drinking_habits": "Hábitos de consumo de alcohol",
        "driver_s_licenses": "Permisos de conducir",
        "drug_habits": "Hábitos de consumo de drogas",
        "eating_habits": "Hábitos alimentarios",
        "education_levels": "Niveles educativos",
        "email_addresses": "Direcciones de correo electrónico",
        "email_messages": "Mensajes de correo electrónico",
        "employers": "Empleadores",
        "employment_statuses": "Situación laboral",
        "encrypted_keys": "Claves cifradas",
        "ethnicities": "Orígenes étnicos",
        "family_members_names": "Nombres de familiares",
        "family_plans": "Planes familiares",
        "family_structure": "Estructura familiar",
        "financial_investments": "Inversiones financieras",
        "financial_transactions": "Transacciones financieras",
        "fitness_levels": "Niveles de condición física",
        "genders": "Géneros",
        "geographic_locations": "Ubicaciones geográficas",
        "government_issued_i_ds": "Documentos de identidad oficiales",
        "health_insurance_information": "Información del seguro médico",
        "historical_passwords": "Contraseñas anteriores",
        "hiv_statuses": "Estado serológico del VIH",
        "home_loan_information": "Información sobre préstamos hipotecarios",
        "home_ownership_statuses": "Situación de propiedad de la vivienda",
        "homepage_ur_ls": "URL de páginas de inicio",
        "imei_numbers": "Números IMEI",
        "imsi_numbers": "Números IMSI",
        "income_levels": "Niveles de ingresos",
        "instant_messenger_identities": "Identidades de mensajería instantánea",
        "ip_addresses": "Direcciones IP",
        "job_applications": "Solicitudes de empleo",
        "job_titles": "Cargos profesionales",
        "licence_plates": "Matrículas",
        "living_costs": "Costes de vida",
        "login_histories": "Historiales de inicio de sesión",
        "mac_addresses": "Direcciones MAC",
        "marital_statuses": "Estados civiles",
        "mnemonic_phrases": "Frases mnemotécnicas",
        "mothers_maiden_names": "Apellidos de soltera de las madres",
        "names": "Nombres",
        "nationalities": "Nacionalidades",
        "net_worths": "Patrimonios netos",
        "nicknames": "Apodos",
        "occupations": "Profesiones",
        "parenting_plans": "Planes de crianza",
        "partial_credit_card_data": "Datos parciales de tarjetas de crédito",
        "partial_dates_of_birth": "Fechas de nacimiento parciales",
        "passport_numbers": "Números de pasaporte",
        "password_hints": "Pistas de contraseñas",
        "password_strengths": "Seguridad de las contraseñas",
        "passwords": "Contraseñas",
        "payment_histories": "Historiales de pagos",
        "payment_methods": "Métodos de pago",
        "personal_descriptions": "Descripciones personales",
        "personal_health_data": "Datos de salud personales",
        "personal_interests": "Intereses personales",
        "phone_numbers": "Números de teléfono",
        "photos": "Fotos",
        "physical_addresses": "Direcciones postales",
        "physical_attributes": "Características físicas",
        "pi_ns": "Códigos PIN",
        "places_of_birth": "Lugares de nacimiento",
        "political_donations": "Donaciones políticas",
        "political_views": "Opiniones políticas",
        "private_messages": "Mensajes privados",
        "professional_skills": "Competencias profesionales",
        "profile_photos": "Fotos de perfil",
        "profile_statistics": "Estadísticas del perfil",
        "purchases": "Compras",
        "purchasing_habits": "Hábitos de compra",
        "races": "Razas",
        "recovery_email_addresses": "Direcciones de correo de recuperación",
        "relationship_statuses": "Situaciones sentimentales",
        "religions": "Religiones",
        "reward_program_balances": "Saldos de programas de fidelización",
        "salutations": "Tratamientos",
        "school_grades_class_levels": "Cursos escolares",
        "security_questions_and_answers": "Preguntas y respuestas de seguridad",
        "sexual_fetishes": "Fetiches sexuales",
        "sexual_orientations": "Orientaciones sexuales",
        "smoking_habits": "Hábitos de consumo de tabaco",
        "sms_messages": "Mensajes SMS",
        "social_connections": "Conexiones sociales",
        "social_media_profiles": "Perfiles en redes sociales",
        "social_security_numbers": "Números de la seguridad social",
        "spoken_languages": "Idiomas hablados",
        "spouses_names": "Nombres de cónyuges",
        "support_tickets": "Solicitudes de asistencia",
        "survey_results": "Resultados de encuestas",
        "taxation_records": "Registros fiscales",
        "telecommunications_carrier": "Operador de telecomunicaciones",
        "time_zones": "Zonas horarias",
        "travel_habits": "Hábitos de viaje",
        "user_statuses": "Estados de usuarios",
        "user_website_ur_ls": "URL de sitios web de usuarios",
        "usernames": "Nombres de usuario",
        "utility_bills": "Facturas de suministros",
        "vehicle_details": "Datos de vehículos",
        "website_activity": "Actividad en sitios web",
        "work_habits": "Hábitos de trabajo",
        "years_of_professional_experience": "Años de experiencia profesional"
      }
    },
    "certificates": {
      "compliance": "Formación en ciberseguridad"
    },
    "courses": {
      "toc": {
        "breach-content": "Filtraciones de datos",
        "file-content": "Descargar",
        "intro-content": "Introducción",
        "quiz-content": "Cuestionario",
        "text-content": "Caso",
        "video-content": "Vídeo"
      }
    },
    "locales": {
      "current": "Español",
      "da_DK": "Danés",
      "de_DE": "Alemán",
      "en_US": "Inglés",
      "es_ES": "Español",
      "fi_FI": "Finés",
      "fr_FR": "Francés",
      "nb_NO": "Noruego",
      "nl_NL": "Neerlandés",
      "pl_PL": "Polaco",
      "pt_PT": "Portugués",
      "sv_SE": "Sueco"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "¡Te damos la bienvenida a tu plataforma de aprendizaje personalizada! Nos alegra que estés aquí y estamos deseando ayudarte a alcanzar tus objetivos de aprendizaje.",
              "title": "Te damos la bienvenida a Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Cómo funciona Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "¡Vamos a empezar! 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Conocimientos sobre privacidad de datos",
          "options": {
            "high": "Los conozco",
            "low": "No los conozco",
            "medium": "Los conozco un poco"
          },
          "question": "¿Hasta qué punto conoces los principios básicos de privacidad de datos, como el RGPD?"
        },
        "device_security": {
          "category": "Prácticas de seguridad de dispositivos",
          "options": {
            "high": "Sí, siempre",
            "low": "No, nunca",
            "medium": "A veces"
          },
          "question": "¿Actualizas tus dispositivos con regularidad y utilizas herramientas de seguridad como una VPN?"
        },
        "digital_threats": {
          "category": "Conocimientos sobre amenazas digitales",
          "options": {
            "high": "Las conozco",
            "low": "No las conozco",
            "medium": "Las conozco un poco"
          },
          "question": "¿Hasta qué punto conoces amenazas digitales como el malware, el phishing y el ransomware?"
        },
        "hybrid_work": {
          "category": "Seguridad en el trabajo a distancia",
          "options": {
            "high": "Tengo mucha confianza",
            "low": "No tengo confianza",
            "medium": "Tengo cierta confianza"
          },
          "question": "¿Qué confianza tienes en tu capacidad para mantener la seguridad al trabajar a distancia, por ejemplo, en una red wifi pública?"
        },
        "incidents_breaches": {
          "category": "Notificación de incidentes",
          "options": {
            "high": "Sí",
            "low": "No",
            "medium": "Tengo una idea general"
          },
          "question": "¿Conoces el procedimiento correcto para notificar un incidente de seguridad o una filtración de datos?"
        },
        "passwords_accounts": {
          "category": "Gestión de contraseñas",
          "options": {
            "high": "Utilizo un gestor de contraseñas",
            "low": "Reutilizo contraseñas",
            "medium": "Creo contraseñas únicas y seguras"
          },
          "question": "¿Cómo gestionas las contraseñas de tus cuentas de trabajo?"
        },
        "phishing": {
          "category": "Identificación del phishing",
          "options": {
            "high": "Tengo mucha confianza",
            "low": "No tengo confianza",
            "medium": "Tengo cierta confianza"
          },
          "question": "¿Qué confianza tienes en tu capacidad para reconocer intentos de phishing en correos o mensajes?"
        },
        "physical_security": {
          "category": "Prácticas de seguridad física",
          "options": {
            "high": "Siempre",
            "low": "Rara vez",
            "medium": "A veces"
          },
          "question": "¿Con qué frecuencia proteges tu espacio de trabajo, por ejemplo, bloqueando el ordenador o guardando los documentos confidenciales?"
        },
        "secure_browsing": {
          "category": "Hábitos de navegación segura",
          "options": {
            "high": "Sí, siempre",
            "low": "No, nunca",
            "medium": "A veces"
          },
          "question": "¿Evitas utilizar redes wifi públicas o hacer clic en enlaces sospechosos al navegar?"
        }
      },
      "steps": {
        "finished": "Finalizado",
        "introduction": "Introducción",
        "quiz": "Cuestionario"
      }
    },
    "partners": {
      "cancer": "la Sociedad Danesa contra el Cáncer",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Suma de verificación no válida",
        "option": "Respuesta no reconocida"
      },
      "intro": {
        "button": "Iniciar cuestionario",
        "text": "Revisaremos 5 correos de tu bandeja de entrada de Moxso. Algunos podrían ser de estafadores que intentan acceder a datos confidenciales. Debes decidir si cada correo es phishing o no. ¿Todo listo?",
        "title": "¿Todo listo para empezar?"
      },
      "multiple-choice": {
        "heading": "Encuentra el error en este correo",
        "text": "Texto de ayuda para preguntas de opción múltiple"
      },
      "options": {
        "email": "El correo electrónico",
        "false": "Esto NO es phishing",
        "help": {
          "email": "El remitente NO es de confianza",
          "false": "Este correo NO debe notificarse",
          "link": "El enlace NO lleva a un destino fiable",
          "not-phishing": "Esto NO es phishing",
          "true": "Este correo debe notificarse"
        },
        "link": "El enlace",
        "not-phishing": "Esto NO es phishing",
        "true": "Esto SÍ es phishing"
      },
      "title": "Cuestionario",
      "true-false": {
        "heading": "¿Es este un correo de phishing?",
        "text": "Determina si este correo es phishing o no"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "No puedes acceder a este curso. Los cursos opcionales están bloqueados, pero la formación obligatoria siempre está disponible.",
          "title": "Este curso está bloqueado"
        },
        "quiz": {
          "description": "Has alcanzado tu límite de formación. Los cuestionarios opcionales están bloqueados por ahora.",
          "title": "Límite de cuestionarios alcanzado"
        },
        "video": {
          "description": "Has alcanzado tu límite de formación. Los vídeos opcionales están bloqueados, pero la formación obligatoria siempre está disponible.",
          "title": "Límite de vídeos alcanzado"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "No puedes acceder a este curso. Los cursos opcionales están bloqueados, pero la formación obligatoria siempre está disponible.",
        "title": "Este curso está bloqueado"
      },
      "quiz": {
        "description": "Has alcanzado tu límite de formación. Los cuestionarios opcionales están bloqueados por ahora.",
        "title": "Límite de cuestionarios alcanzado"
      },
      "reset": "Se restablece el lunes",
      "video": {
        "description": "Has alcanzado tu límite de formación. Los vídeos opcionales están bloqueados, pero la formación obligatoria siempre está disponible.",
        "limit_reached": "Límite alcanzado",
        "title": "Límite de vídeos alcanzado"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "La serie Avanzado está dirigida a quienes tienen un interés especial en la ciberseguridad y quieren comprender cómo funcionan los mecanismos del hacking y la ciberseguridad. Si solo buscas una comprensión básica, no es necesario que veas estos vídeos. Si quieres profundizar en el hacking, los ciberataques y las mejores formas de reforzar tu ciberseguridad, esta serie es para ti.",
          "title": "Avanzado",
          "tooltip": "Conviértete en un experto en hacking en poco tiempo"
        },
        "ai": {
          "text": "La serie sobre IA explora el complejo papel de la inteligencia artificial en la ciberseguridad. La IA tiene una doble función: es una herramienta esencial para que los profesionales de seguridad informática identifiquen y contrarresten amenazas, pero también es un recurso poderoso para los hackers. Esta serie te ayuda a reconocer el phishing generado por IA y a utilizarla de forma segura para reducir errores y el riesgo de sufrir ataques. Aunque la IA es una herramienta potente tanto para la defensa como para el ataque, tu comportamiento sigue siendo decisivo para tu seguridad.",
          "title": "IA y ciberseguridad",
          "tooltip": "Explora el complejo papel de la IA en la ciberseguridad"
        },
        "compliance": {
          "text": "Esta categoría incluye vídeos sobre legislación, normas de seguridad y certificaciones importantes para proteger tu lugar de trabajo frente a las amenazas digitales. Conocerás, entre otros, la Directiva NIS2 y el Reglamento DORA, que establecen medidas sólidas de ciberseguridad y el cumplimiento de normas internacionales. Los vídeos explican la importancia de estas normativas, cómo cumplirlas y sus requisitos de seguridad y gestión de riesgos para las organizaciones. También comprenderás qué significan para ti y por qué merece la pena conocerlas.",
          "title": "Certificaciones y cumplimiento normativo",
          "tooltip": "Comprende la importancia de las certificaciones y el cumplimiento normativo"
        },
        "gdpr": {
          "text": "La serie RGPD profundiza en las reglas, requisitos y principios del Reglamento General de Protección de Datos. El RGPD entró en vigor en 2018 y las empresas deben cumplirlo para garantizar la integridad y la protección de los datos personales que tratan. La serie aborda los aspectos más relevantes que debes conocer para tratar correctamente los datos personales en tu día a día. Sus vídeos están dirigidos a todo el mundo, incluidas las personas que trabajan en el sector privado.",
          "title": "RGPD",
          "tooltip": "Conoce los principales requisitos y reglas del RGPD y cómo cumplirlos en tu día a día"
        },
        "hacking": {
          "text": "La vida de un hacker es una serie sobre las personas que están detrás de los ciberataques. Veremos algunos de los métodos que utilizan para mantenerse anónimos en Internet y cómo ganan dinero. Los vídeos también explican los distintos tipos de hackers y por qué resulta tan difícil atraparlos.",
          "title": "La vida de un hacker",
          "tooltip": "Conoce a las personas que están detrás de los ciberataques"
        },
        "money_laundering": {
          "text": "La serie Blanqueo de capitales profundiza en los métodos que utilizan los delincuentes para blanquear dinero. Los vídeos explican estas técnicas y cómo detectar y prevenir el blanqueo de capitales.",
          "title": "Blanqueo de capitales",
          "tooltip": "Conoce los métodos de blanqueo de capitales y cómo detectarlo y prevenirlo"
        },
        "phishing": {
          "text": "La serie Phishing profundiza en el ciberataque más común del mundo. Un ataque de phishing puede ser un ataque en sí mismo o servir para lanzar otros más avanzados. Tu actuación en el trabajo es fundamental para evitarlo, por ejemplo, no haciendo clic en un enlace de un correo. El phishing es un área esencial de la ciberseguridad. Estos vídeos te ayudarán a comprender qué es, cómo lo llevan a cabo los hackers y cómo evitar convertirte en víctima.",
          "title": "Phishing",
          "tooltip": "Descubre los aspectos del ciberataque más común del mundo"
        },
        "physical_security": {
          "text": "La serie Seguridad física destaca la importancia de una buena seguridad en el trabajo y en casa. La ciberseguridad no solo trata de proteger tus dispositivos, sino también su entorno. Muchas personas trabajan a distancia, y te ayudaremos a hacerlo de la forma más segura posible. Esta serie también aborda la gestión de visitas, la seguridad de los dispositivos móviles y los riesgos de utilizar redes públicas.",
          "title": "Seguridad física",
          "tooltip": "Descubre por qué la seguridad física es esencial para una buena ciberseguridad"
        },
        "tips_and_tricks": {
          "text": "La serie Consejos y trucos te ayudará a reforzar tu ciberseguridad. Aprenderás formas concretas y sencillas de mejorar tu seguridad personal en Internet y, con ello, la de tu lugar de trabajo. Los vídeos también explican por qué es importante recordar los consejos de ciberseguridad que hayas recibido anteriormente.",
          "title": "Consejos y trucos",
          "tooltip": "Aprende a mejorar tu ciberseguridad personal"
        },
        "types_of_hacking": {
          "text": "La serie Tipos de hacking presenta los distintos métodos que utilizan los hackers para engañarte. Cada episodio explica las características de una técnica, qué pueden conseguir con ella y qué consecuencias puede tener para ti si sufres un ataque. Estos vídeos te ayudarán a prepararte mejor frente a futuros ataques.",
          "title": "Tipos de hacking",
          "tooltip": "Conoce los distintos métodos que utilizan los hackers"
        },
        "uploads": {
          "text": "Esta categoría incluye vídeos personalizados que ha subido tu organización.",
          "title": "Vídeos subidos",
          "tooltip": "Mira los vídeos de tu organización adaptados a tus necesidades de seguridad"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Se ha notificado el error a nuestro equipo con el identificador {errorId}.\n Si necesitas ayuda inmediata, contacta con nuestro equipo de asistencia en support{'@'}moxso.com.",
    "go_back": "Volver al inicio",
    "text": "Se ha producido un error desconocido y no hemos podido completar tu solicitud. Sentimos las molestias. Inténtalo más tarde.",
    "title": "Se ha producido un error"
  },
  "forms": {
    "fields": {
      "code": "Contraseña de un solo uso",
      "email": "Correo electrónico"
    },
    "placeholders": {
      "email": "nombre{'@'}empresa.com"
    }
  },
  "loading": "Cargando",
  "locale": {
    "current": "Español",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Iniciar sesión",
      "next": "Siguiente",
      "send_one_time_code": "Enviar código de un solo uso",
      "try_again": "Reenviar código"
    },
    "choose_provider": "Elegir proveedor",
    "loading": "Cargando",
    "sso": {
      "validating": "Validando el inicio de sesión único"
    },
    "title": "Iniciar sesión",
    "two_factor": {
      "text": "Te hemos enviado una contraseña de un solo uso por correo electrónico.",
      "title": "Revisa tu correo electrónico"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Has completado el contenido destacado que tu administrador ha elegido para ti.",
      "title": "¡Bien hecho!"
    },
    "deadline": "Fecha límite de finalización: {date}",
    "next_training": "Siguiente formación asignada",
    "policy_fallback_title": "Política",
    "quiz_questions": "{count} pregunta | {count} preguntas",
    "retake": "Reasignado",
    "start_quiz": "Iniciar cuestionario",
    "text": "Tu formación asignada",
    "title": "Formación asignada",
    "view_policy": "Ver política"
  },
  "navigation": {
    "breaches": "Filtraciones",
    "courses": "Cursos",
    "exit": "Salir",
    "exit_onboarding": "Omitir la introducción",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "onboarding": "Introducción",
    "onboarding_finished": "Introducción completada",
    "onboarding_intro": "Presentación inicial",
    "onboarding_quiz": "Cuestionario inicial",
    "overview": "Inicio",
    "simulation_click": "Simulación de phishing",
    "simulations": "Simulaciones",
    "videos": "Vídeos"
  },
  "onboarding": {
    "finished": {
      "button": "Empezar a aprender",
      "subtitle": "¡Has completado tu introducción! Buen trabajo: ya puedes empezar a utilizar Moxso. Nos alegra que estés aquí y estamos deseando ayudarte a alcanzar tus objetivos.",
      "title": "¡Todo listo!"
    },
    "intro": {
      "form": {
        "button": "Guardar y continuar",
        "help": "Elige el idioma que quieres utilizar para tu aprendizaje.",
        "label": "Selecciona tu idioma",
        "placeholder": "Seleccionar idioma"
      },
      "header": {
        "description": "¡Te damos la bienvenida a tu plataforma de aprendizaje! Nos alegra que estés aquí y estamos listos para ayudarte a alcanzar tus objetivos. Vamos a configurar tu perfil y personalizar tu experiencia.",
        "title": "Te damos la bienvenida a Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Completa este breve cuestionario para que podamos conocer tu nivel actual y adaptar la formación a tus necesidades.",
        "title": "¿Cuánto sabes de ciberseguridad?"
      }
    }
  },
  "overview": {
    "start_quiz": "Iniciar cuestionario",
    "welcome": "Te damos la bienvenida de nuevo"
  },
  "partner_text": "La plataforma Moxso se presenta en colaboración con {partner}.",
  "policies": {
    "cancel": {
      "text": "Tu administrador ha cancelado esta política.",
      "title": "Política cancelada"
    },
    "continue": "Continuar",
    "expired": {
      "text": "Esta política ha caducado y ya no está disponible.",
      "title": "Política caducada"
    },
    "focus": "Concentración",
    "history": {
      "count": "{count} firmadas",
      "show_less": "Mostrar menos",
      "signed": "Firmada el {date}",
      "subtitle": "Revisar políticas firmadas",
      "title": "Políticas",
      "view_more": "Mostrar más"
    },
    "next": "Siguiente",
    "overview": "Resumen del contenido",
    "policy": "Política",
    "quiz": {
      "confirmation_card_locked": "Debes completar el cuestionario para continuar",
      "subtitle": "Demuestra que comprendes la política con este cuestionario.",
      "subtitle_completed": "Has completado el cuestionario. Confirma que has leído la política para finalizar.",
      "title": "Cuestionario",
      "title_completed": "Cuestionario completado"
    },
    "reader": "Lector",
    "signature": {
      "button": "Confirmar",
      "checkbox_label": "He leído la política",
      "company": "Empresa",
      "completed": {
        "button": "Salir",
        "policy_completed": "Política aceptada",
        "subtitle": "¡Buen trabajo! Has aceptado la política.",
        "title": "Política aceptada"
      },
      "ip_adress": "Dirección IP",
      "subtitle": "Al confirmar, reconoces que has leído y comprendido la política.",
      "title": "Confirmar la lectura de la política",
      "user_agent": "Agente de usuario"
    },
    "this_policy_doesnt_exist_in_this_language": "Esta política no está disponible en español. Se muestra la versión en {locale}."
  },
  "quiz": {
    "analyze": {
      "text": "Analiza este correo y obtén ayuda",
      "title": "¿Tienes dudas?"
    },
    "feedback": {
      "no": "No",
      "text": "¿Te ha resultado útil esta página?",
      "thanks": "¡Gracias por tus comentarios!",
      "yes": "Sí"
    },
    "help": {
      "button": "Siguiente pregunta",
      "text": "Hemos analizado el correo y obtenido el siguiente resultado",
      "title": "Análisis del correo"
    },
    "intro": {
      "button": "Iniciar cuestionario",
      "text": "Revisaremos 5 correos de tu bandeja de entrada de Moxso. Algunos podrían ser de estafadores que intentan acceder a datos confidenciales. Debes decidir si cada correo es phishing o no. ¿Todo listo?",
      "title": "¿Todo listo para empezar?"
    },
    "preview": "Vista previa del correo",
    "question": "Pregunta {current} de {total}",
    "result": {
      "go_back": "Volver a inicio",
      "mails": "Correo detectado | Correos detectados",
      "points": "Puntos obtenidos",
      "text": {
        "bad": "Solo has clasificado correctamente {count} correo. Pero recuerda: ¡la práctica hace al maestro! | Solo has clasificado correctamente {count} correos. Pero recuerda: ¡la práctica hace al maestro!",
        "good": "Has clasificado correctamente {count} correos y completado el cuestionario. ¡Sigue así!"
      },
      "title": {
        "bad": "Más suerte la próxima vez",
        "good": "¡Bien hecho!"
      }
    },
    "title": "Cuestionario"
  },
  "resilience_score": {
    "long_text": "La puntuación de resiliencia mide tu capacidad para resistir ciberataques. Se calcula a partir de tu comportamiento en cuestionarios, vídeos y simulaciones, así como de tus habilidades. Cuanto mayor sea tu puntuación, mejor podrás protegerte y proteger a tu lugar de trabajo frente a los ciberataques.",
    "quizzing": {
      "text": "Mejora tus resultados en los cuestionarios de opción múltiple para reforzar tu resiliencia.",
      "title": "Cuestionarios"
    },
    "show_breakdown": "Mostrar desglose",
    "simulations": {
      "text": "Actuar con seguridad ante el phishing mejora tu resiliencia. ¡No hagas clic y recuerda denunciarlo!",
      "title": "Simulaciones"
    },
    "skills": {
      "text": "Tus habilidades dependen de tus resultados en los cuestionarios. Las respuestas correctas aumentan tu resiliencia.",
      "title": "Habilidades"
    },
    "text": "La puntuación de resiliencia mide tu capacidad para resistir ciberataques.",
    "title": "Tu puntuación de resiliencia",
    "videos": {
      "text": "Los vídeos son una parte importante de tu formación. Refuerza tu resiliencia viéndolos.",
      "title": "Vídeos"
    }
  },
  "search": {
    "empty": "Busca algo para empezar...",
    "no_results": "No se han encontrado resultados",
    "placeholder": "Buscar...",
    "popular": "Búsquedas populares",
    "popular_terms": ["Ransomware", "Ingeniería social"]
  },
  "simulation": {
    "alert": {
      "text": "Este correo forma parte de un ejercicio automatizado de phishing, pero no te preocupes: solo es una prueba.",
      "title": "Esto es una simulación de phishing"
    },
    "baseline": {
      "text": "Estamos poniendo a prueba a tus compañeros. Te pedimos que no compartas este mensaje.",
      "title": "¿Puedes guardar un secreto?"
    },
    "branding": {
      "text": "Estamos aquí para ayudarte. No dudes en contactarnos.",
      "title": "Este ejercicio ha sido enviado por Moxso"
    },
    "delivered_by": {
      "text": "Moxso ha enviado este ejercicio en nombre de {companyName}. Si tienes alguna pregunta, contacta con {contactEmail}.",
      "title": "Acerca de este ejercicio"
    },
    "preview": "Vista previa del correo",
    "resilience_score": {
      "text": "Tu puntuación de resiliencia mide tu capacidad para resistir ciberataques.",
      "title": "Tu puntuación de resiliencia"
    },
    "submission": {
      "text": "Has hecho clic en un enlace y has llegado a una página falsa, aunque convincente. En un ataque de phishing real, podrían haber robado tus credenciales. Por suerte, solo era una prueba.",
      "title": "¿Qué acaba de pasar?"
    },
    "training": {
      "button": "Inicia tu formación"
    }
  },
  "simulations": {
    "count": "Has recibido {count} simulaciones de Moxso en los últimos 90 días.",
    "empty": {
      "text": "No has recibido ninguna simulación en los últimos 90 días.",
      "title": "No se han encontrado simulaciones"
    },
    "joined": "Incorporación al programa de formación de Moxso",
    "title": "Simulaciones",
    "tooltip": {
      "click": "Has hecho clic en el enlace de esta simulación",
      "report": "Has denunciado esta simulación",
      "submit": "Has iniciado sesión en esta simulación."
    }
  },
  "sso": {
    "login_with": "Continuar con {provider}",
    "or": "o utiliza el inicio de sesión único",
    "redirect": "Redirigiendo"
  },
  "statistics": {
    "leaderboard": "Clasificación",
    "missing_data": {
      "text": "Necesitas obtener puntos para ver tu posición en la clasificación",
      "title": "Obtén puntos para ver tu posición"
    },
    "points_earned": "{count} puntos obtenidos",
    "resilience_score": "Puntuación de resiliencia"
  },
  "videos": {
    "error": "La reproducción de vídeo no está disponible en este momento",
    "latest": "Últimos vídeos",
    "more": "Ver más",
    "not_available_in_your_locale": "Este vídeo no está disponible en español. Hemos cambiado automáticamente a otro idioma.",
    "play": "Reproducir vídeo",
    "quiz": {
      "resume": "Reanudar cuestionario",
      "title": "Cuestionario"
    },
    "related": "Vídeos relacionados",
    "related_videos": "Vídeos sugeridos",
    "title": "Vídeos",
    "watch_again": "Volver a ver"
  }
}
